// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__BCo_3","none":"banner_none__3h6Rk"};